<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container [formGroup]="accountInformations">
      <div class="row">
        <div class="col-md-12">
          <pr-input-radio
            [derrors]="derrors"
            formControlName="investmentHorizon"
            direction="column"
            [isDefault]="false"
            columns="1"
            [options]="options"
            label="Quel est votre horizon d'investissement ?"
          >
          </pr-input-radio>
        </div>
      </div>
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
